import { getObjectColors } from '../../utils/objectColors';

interface ObjectChipProps {
  objectKey: string | null | undefined;
  label: string;
  size?: 'sm' | 'md';
  className?: string;
}

export function ObjectChip({ objectKey, label, size = 'sm', className = '' }: ObjectChipProps) {
  const colors = getObjectColors(objectKey ?? label);
  const padding = size === 'sm' ? 'px-2 py-0.5' : 'px-2.5 py-1';
  const text = size === 'sm' ? 'text-[11px]' : 'text-xs';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium ${padding} ${text} ${className}`}
      style={{ background: colors.soft, color: colors.ink }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: colors.color }} />
      <span className="truncate max-w-[10rem]">{label}</span>
    </span>
  );
}
